<template>
  <div>
    <el-card class="contact-card">
      <div slot="header" class="clearfix">
        <span class="contact-title">联系方式</span>
      </div>

      <el-descriptions :column="1" border>
        <el-descriptions-item label="公司名称"> 河南郑大水利科技有限公司 </el-descriptions-item>
        <el-descriptions-item label="公司地址">
          河南省郑州市高新区翠竹街100号郑大科技园2号楼217室
        </el-descriptions-item>
        <el-descriptions-item label="公司电话">
          <!-- <el-link type="primary" :href="'tel:0371-61287669'"
            >0371-61287669</el-link
          > -->
          0371-61287669
        </el-descriptions-item>
        <el-descriptions-item label="邮政编码">450001</el-descriptions-item>
        <el-descriptions-item label="公司邮箱">
          <!-- <el-link type="primary" :href="'mailto:hnzdslkj@163.com'"
            >hnzdslkj@163.com</el-link
          > -->
          hnzdslkj@163.com
        </el-descriptions-item>
      </el-descriptions>
    </el-card>
    <SiteFooter />
  </div>
</template>

<script>
  import SiteFooter from '../components/SiteFooter.vue'
  export default {
    components: { SiteFooter }
  }
</script>

<style scoped>
  .contact-card {
    margin: 20px 0 0 0;
    height: 600px;
    /* max-width: 800px; */
  }

  .contact-title {
    font-size: 18px;
    font-weight: bold;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: '';
  }
  .clearfix:after {
    clear: both;
  }

  .el-descriptions {
    margin-top: 20px;
  }

  .el-tag {
    font-size: 14px;
  }

  .el-link {
    font-size: 14px;
  }
</style>
